export enum AppActionsEnum {
    CREATE_VANITY_URL = 'createVanityUrl',
    GET_URL_CLICK_STATS = 'getUrlClickStats',
    URL_CLICK_STATS_BY_DAY = 'UrlClickStatsByDay',
    GET_ALL_URLS = 'getAllUrls',
}
